import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface EOToast {
  id: string;
  msg: string;
  kind?: '' | 'danger' | 'success';
  params?: Record<string, string>;
}

export interface EOUiState {
  toasts: EOToast[];
}

const initialState: EOUiState = {
  toasts: [],
};

const eoUiSlice = createSlice({
  name: 'eoUi',
  initialState,
  reducers: {
    pushToast(
      state,
      action: PayloadAction<{ msg: string; kind?: EOToast['kind']; params?: Record<string, string> }>,
    ) {
      state.toasts.push({
        id: `${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
        msg: action.payload.msg,
        kind: action.payload.kind,
        params: action.payload.params,
      });
    },
    removeToast(state, action: PayloadAction<string>) {
      state.toasts = state.toasts.filter((t) => t.id !== action.payload);
    },
  },
});

export const { pushToast, removeToast } = eoUiSlice.actions;
export default eoUiSlice.reducer;
